<p-toast position="top-right"></p-toast>
<app-header></app-header>
<section class="main-sec" id = "main-outer" [class.ios-web-view] = "_responsiveCheck.iosWebViewCheck()">
  <router-outlet></router-outlet>
</section>
<app-footer [isExtraPaddingRoute]="isExtraPaddingRoute"></app-footer>
